import { Button, FormatText, GridView, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import TableCicloOrcamentarioPluriAnual from '../RelatorioCicloOrcamentarioPluriAnual/TableCicloOrcamentarioPluriAnual';
import { CicloOrcamentarioRelatorio } from '@app/api/relatorioCicloorcamentario';
import { exportarFechamentoPluriAnual, getFechamentoPluriAnualByFechamentoId } from '@app/api/fechamento';
import { hasPermission } from '@app/helpers/permissions';
const { Panel } = Collapse;

interface FechamentoPluriAnualProps {
  fechamentoId: string;
}

const FechamentoPluriAnual = (props: FechamentoPluriAnualProps) => {
  const { fechamentoId } = props;

  const [cicloOrcamentarioRelatorioTotal, setCicloOrcamentarioRelatorioTotal] = useState<CicloOrcamentarioRelatorio>();

  useEffect(() => {
    getFechamentoPluriAnualByFechamentoId(fechamentoId).then(result => {
      setCicloOrcamentarioRelatorioTotal(result);
    });
  }, [fechamentoId]);

  const btnExportar = () => {
    if (fechamentoId && hasPermission(['FECHAMENTO_PLURI_ANUAL_BOTAO_EXPORTA_RELATORIO_VISUALIZAR'])) {
      return [
        <Button
          type="primary"
          size={'small'}
          icon="files-ms_excel"
          onClick={() => {
            exportarFechamentoPluriAnual(fechamentoId, 'pluriAnualRelatorio.xlsx');
          }}>
          Exporta Relatório
        </Button>,
      ];
    }
    return [];
  };

  return (
    <GridView noform>
      <Widget title="RESULTADO" span={12} actions={btnExportar()}>
        {cicloOrcamentarioRelatorioTotal && fechamentoId ? (
          <TableCicloOrcamentarioPluriAnual
            cicloOrcamentarioRelatorioTotal={cicloOrcamentarioRelatorioTotal}
            ocultarColunaDetalhe={true}
            mostrarColunaDetalheFechamento={true}
            fechamentoId={fechamentoId}
            paginacaoConfig={{
              pageSize: 10,
              onChange: () => {
                //document.getElementById("tableCicloOrcamentarioPluriAnual").scrollIntoView();
              },
            }}
          />
        ) : (
          <></>
        )}
      </Widget>
    </GridView>
  );
};

export default FechamentoPluriAnual;
